import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminUsers from "./pages/AdminUsers";
import ConferenceHub from "./pages/ConferenceHub";
import CrmHome from "./pages/CrmHome";
import CounterpartiesDirectory from "./pages/CounterpartiesDirectory";
import PriceMonitoring from "./pages/PriceMonitoring";
import SiteTasks from "./pages/SiteTasks";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import WorkspaceLayout from "./components/WorkspaceLayout";
import { getRouterBasename } from "./services/appRoutes";

function App() {
    const routerBasename = getRouterBasename();
    const crmHome = <ProtectedRoute><WorkspaceLayout><CrmHome /></WorkspaceLayout></ProtectedRoute>;

    return (
        <AuthProvider>
            <Router basename={routerBasename}>
                <Navbar />
                <Routes>
                    <Route path="/" element={routerBasename ? crmHome : <Navigate to="/crm" replace />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/crm" element={routerBasename ? <Navigate to="/" replace /> : crmHome} />
                    <Route path="/counterparties" element={<ProtectedRoute><WorkspaceLayout><CounterpartiesDirectory /></WorkspaceLayout></ProtectedRoute>} />
                    <Route path="/price-monitoring" element={<ProtectedRoute><WorkspaceLayout><PriceMonitoring /></WorkspaceLayout></ProtectedRoute>} />
                    <Route path="/price-monitoring/favorites" element={<ProtectedRoute><WorkspaceLayout><PriceMonitoring favoriteOnly /></WorkspaceLayout></ProtectedRoute>} />
                    <Route path="/conf" element={<ProtectedRoute><WorkspaceLayout><ConferenceHub /></WorkspaceLayout></ProtectedRoute>} />
                    <Route path="/site-tasks" element={<ProtectedRoute><WorkspaceLayout><SiteTasks /></WorkspaceLayout></ProtectedRoute>} />
                    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path="/admin/users" element={<ProtectedRoute requireSuperadmin><WorkspaceLayout><AdminUsers /></WorkspaceLayout></ProtectedRoute>} />
                    <Route path="*" element={<Navigate to="/crm" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
